import {Button} from '@wandb/components';
// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon} from '@wandb/weave/components/Icon';
import * as React from 'react';

export const EmptyRunIssuesDrawer = () => {
  return (
    <div
      className="flex flex-col items-center justify-start px-24 py-40"
      data-test="empty-run-issues-drawer">
      <div className="flex h-64 w-64 items-center justify-center rounded-full bg-[#CDF4F7]">
        <Icon name="system-chip" className="h-32 w-32" />
      </div>
      <div className="mt-16 text-center text-2xl font-semibold">
        No cluster issues
      </div>
      <p className="mt-8 text-center text-lg">
        Cluster issues that occur on CoreWeave hardware during runs will show
        here and be visible on line plots.{' '}
      </p>
      <footer className="mt-24 flex items-center justify-center">
        <Button variant="secondary" startIcon="documentation">
          Documentation
        </Button>
      </footer>
    </div>
  );
};
